import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { setGlobalLogout, fetchWithAuth, API_URL } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

// --- ESTADOS DE NOTIFICACIONES ---
  const [friendRequests, setFriendRequests] = useState([]); // Antes era pendingRequests
  const [eventRequests, setEventRequests] = useState([]);   // NUEVO: Solicitudes de eventos

  const login = (userData) => {
    setUser(userData);
    // CLEAN FIRST
    localStorage.removeItem('promoter_ref');
    localStorage.removeItem('redirectAfterRegister');

    localStorage.setItem('user', JSON.stringify(userData));
    fetchNotifications();
  };

  const logout = () => {
    setUser(null);
    setFriendRequests([]);
    setEventRequests([]);
    
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('promoter_ref');
    localStorage.removeItem('redirectAfterRegister');
  };

  // Función para recargar TODAS las notificaciones
  const fetchNotifications = useCallback(async () => {
    // Solo intentamos si hay token
    if (!localStorage.getItem('token')) return;

    try {
      // Usamos Promise.all para hacer las dos peticiones en paralelo
      const [friendsData, eventsData] = await Promise.all([
        fetchWithAuth(`${API_URL}/friends/requests/received`).catch(() => []), // Si falla, devuelve array vacío
        // NOTA: Asegúrate de tener este endpoint en tu backend o usa la lógica para buscar en tus eventos
        fetchWithAuth(`${API_URL}/my-event-requests`).catch(() => []) 
      ]);

      setFriendRequests(Array.isArray(friendsData) ? friendsData : []);
      
      // Filtramos solo las pendientes por si acaso el backend devuelve todas
      const pendingEvents = Array.isArray(eventsData) ? eventsData.filter(r => !r.approved) : [];
      setEventRequests(pendingEvents);

    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  }, []);

  useEffect(() => {
    setGlobalLogout(logout);
    if (user) {
      fetchNotifications();
      // Opcional: Polling cada 60 segundos
      const interval = setInterval(fetchNotifications, 60000);
      return () => clearInterval(interval);
    }
  }, [user, fetchNotifications]);

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      logout, 
      friendRequests, // Exponemos solicitudes de amistad
      eventRequests,  // Exponemos solicitudes de eventos
      fetchNotifications 
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};